
const defaultProps = {
  /* The type of action performed by the automated message */
  imageSrc: null,
  /* Whether this message flow is completed */
  label: '',
  /* Detail text for the message */
  value: ''
};

const convertInternal = (whMessageFlowOption) => {
  return {
    imageSrc: whMessageFlowOption.imageSrc || defaultProps.imageSrc,
    label: whMessageFlowOption.label || defaultProps.label,
    value: whMessageFlowOption.value || defaultProps.value
  };
};

class MessageFlowOption {
  /**
   * Creates a new ConversationMember based on the server response
   * @argument whConversationMember: server response member info
   */
  static createFromWarehouseResponse ({ whMessageFlowOption }) {
    return new MessageFlowOption({
      ...convertInternal(whMessageFlowOption)
    });
  }

  /** Creates a new MessageFlowOption
   * @argument fields: The attributes to add to this instance
   */
  constructor (fields = defaultProps) {
    Object.assign(this, fields);
  }

  /** Generates a copy of the MessageFlowOption instance
   * @argument overrides: The attributes to add to the new instance
  */
  makeCopy (overrides) {
    return new MessageFlowOption({
      imageSrc: this.imageSrc,
      label: this.label,
      value: this.value,
      ...overrides
    });
  }
}

export default MessageFlowOption;
